import type { IStockRepository, BalanceListOptions } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockBalanceEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createListBalancesUseCase({ stockRepository }: Deps) {
  return async function listBalances(options: BalanceListOptions): Promise<StockBalanceEntity[]> {
    return stockRepository.listBalances(options);
  };
}
